import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { PageHead } from "@/components/Layouts";
import { Loading } from "@/components/Bits";
import { Pipeline } from "./Overview";

export default function Enquiries() {
  const { user } = useAuth();
  const [tab, setTab] = useState(user.active_mode === "seller" ? "seller" : "buyer");
  const [items, setItems] = useState(null);
  useEffect(() => { setItems(null); api.get("/enquiries", { params: { as_role: tab } }).then((r) => setItems(r.data)); }, [tab]);
  return (
    <div>
      <PageHead eyebrow="Conversations" title="Enquiries & acquisition pipeline" sub="Private conversations linked to each listing, with stages, offers, NDA and document access." />
      <div className="flex gap-1 p-1 rounded-full bg-[#E9DDCB] w-fit mb-6" role="tablist">
        {[["buyer", "As buyer"], ["seller", "As seller"]].map(([k, t]) => <button key={k} role="tab" aria-selected={tab === k} onClick={() => setTab(k)} className={`px-4 py-2 rounded-full text-sm font-semibold ${tab === k ? "bg-[#29483D] text-white" : ""}`} data-testid={`enquiries-tab-${k}`}>{t}</button>)}
      </div>
      {items === null ? <Loading /> : <Pipeline enq={items} />}
    </div>
  );
}
